import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import { getPatient, getMasterData } from '../../actions/index';
import history from '../../../../history';

const validate = (values) => {
  const errors = {};

  if (!values.patientId) {
    errors.patientId = 'Please select client.';
  }

  if (!values.masterNoteTypeId) {
    errors.masterNoteTypeId = 'Please select note type.';
  }

  return errors;
};

class HIH_Sessionnotes_Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      patientId: 0,
      masterNoteTypeId: 1,
      iframeURL: '',
      isLoading: false,
      random: 0,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      includeClinicalData: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);    
    this.checkReportSearch = this.checkReportSearch.bind(this);
  }

  componentWillMount() {
    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);

    let masterData = {
      'masterdata': 'MASTERNOTETYPE',
    };
    this.props.getMasterData(masterData);
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);
    let reportName = base64Encode('CL_DefaultSessionNotes_RPT');

    if(this.state.masterNoteTypeId === 1)
      reportName = base64Encode('CL_DefaultSessionNotes_RPT');
    else if(this.state.masterNoteTypeId === 2)
    {
      if(this.state.patientId === 3 || this.state.patientId === 19)
      {
        reportName = base64Encode('CL_DefaultSessionNotes_RPT');
      }
      else
      {
        reportName = base64Encode('CL_SessionSupervisionNotes_HIH_RBT');   
      }      
    }
    if(this.state.masterNoteTypeId === 1) {      
      this.setState({
        isLoading: true,
        iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "PatientId","Value": "` + this.state.patientId + `"},{"Name": "NoteTypeId","Value": "` + this.state.masterNoteTypeId + `"},{"Name": "FromAppointmentDate","Value": "` + FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "` + ToDateFormat + `"},{"Name": "IncludeClinicalData","Value": "` + this.state.includeClinicalData + `"},{"Name": "Offset","Value": "` + moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
      });
    }
    else
    {
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "PatientId","Value": "` + this.state.patientId + `"},{"Name": "NoteTypeId","Value": "` + this.state.masterNoteTypeId + `"},{"Name": "FromAppointmentDate","Value": "` + FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "` + ToDateFormat + `"},{"Name": "Offset","Value": "` + moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
    }
  }

  checkReportSearch = (e, name) => {
    if (name === 'includeClinicalData') {
      if(e.target.checked) 
      {
        this.setState({includeClinicalData : true});        
      }
      else
      {
        this.setState({includeClinicalData : false});
      }
    }    
  }


  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }


  handleChange = (input, selectedRecord) => {
    this.setState({ [input.name]: selectedRecord.value });
    input.onChange(selectedRecord.value);
  }

  // handleNewRequest = (input, selectedRecord) => {
  //   let appointmentType = this.props.appointmentType.filter((obj) => obj.id === selectedRecord.value);
  //   this.setState({ [input.name]: selectedRecord.value, masterNoteTypeId: appointmentType[0].masterNoteType.id }); 
  //   input.onChange(selectedRecord.value);
  // }

  onLoadReport = (e) => {
    this.setState({ isLoading: false });
  }

  resetIframe() {
    this.setState({ random: this.state.random + 1 });
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/audit-tools-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Audit Tools {' > '} Session Notes Report</h2>
        :
          <h2 className="page_title">Session Notes Report</h2>
        }  
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="patientId"
                    label="Select Client"
                    handleNewRequest={this.handleChange}
                    options={this.props.patientlist}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="masterNoteTypeId"
                    label="Select Note Type"
                    handleNewRequest={this.handleChange}
                    options={this.props.masterNoteType}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 require mt-35">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                {this.state.masterNoteTypeId === 1 && 
                  <div className="col-sm-4 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="includeClinicalData"
                        label="Include Clinical Data"
                        onChange={(e) => this.checkReportSearch(e, 'includeClinicalData')}
                        component={renderCheckBox}
                      />
                  </div>   }
              </div>
              <div className="row">
                <div className="col-sm-3 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e) => this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

HIH_Sessionnotes_Report = reduxForm({
  form: 'HIH_Sessionnotes_Report',
  validate,
  enableReinitialize: true,
})(HIH_Sessionnotes_Report);

function mapStateToProps(state) {
  let patients = [];
  if (state.report.patientList && state.report.patientList.data) {
    patients = state.report.patientList.data.patients;
  }
  // console.log('state.report.master_data............',state.report.master_data.allStaffs)
  return {
    orgID: state.login.loginUserInfo.organizationID,
    patientlist: patients,
    masterNoteType: state.report.master_data && state.report.master_data.masterNoteType,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, { getPatient, getMasterData })(HIH_Sessionnotes_Report);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/AuditToolsReports/HIH_Sessionnotes_Report.js